class PredictiveSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.getSearchDefault()
  }

  setupListeners () {
    super.setupListeners()

    this.onClick = this.onClick.bind(this)
    this.els.input.element.addEventListener('click', this.onClick)

    this.onClose = this.onClose.bind(this)
    this.externalEls.backdrop.element.addEventListener('click', this.onClose)

    this.onTrigger = this.onTrigger.bind(this)
    this.externalEls.trigger.element.addEventListener('click', this.onTrigger)

    this.listeners.add(
      this.els.input.element,
      'input',
      window.BAO.Utils.debounce(e => {
        this.onChange(e)
      }, 500).bind(this),
    )
  }

  onProductsClick () {
    this.productsClick()
  }

  onArticlesClick () {
    this.articlesClick()
  }

  onClick () {
    this.open()
  }

  onClose () {
    this.close()
  }

  onTrigger () {
    this.focusAndOpenKeyboard()
  }

  onChange () {
    const searchTerm = this.els.input.element.value.trim()

    this.hideDefault(true)
    this.hideResults(false)

    if (!searchTerm.length) {
      this.hideDefault(false)
      this.hideResults(true)
      return
    }

    this.getSearchResults(searchTerm)
    this.getProductSearch(searchTerm)
  }

  getSearchDefault () {
    window.BAO.sectionRenderer
      .fetch(
        'section-search',
        `${window.Shopify.routes.root}?view=predictive-search`,
      )
      .then(res => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res['section-search'],
        )

        const myself = newDOM.querySelector('#shopify-section-section-search')

        this.els.default.element.innerHTML = myself.outerHTML

        this.hideResults(true)
        this.hideDefault(false)

        this.els.close.element.addEventListener('click', this.onClose)
      })
      .catch(() => {})
  }

  getSearchResults (searchTerm) {
    fetch(
      `${window.Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=query,page,product,collection,article&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=body,product_type,tag,title,variants.title,vendor&section_id=predictive-search`,
    )
      .then(response => {
        if (!response.ok) {
          const error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then(text => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML
        this.els.results.element.innerHTML = resultsMarkup

        this.els.close.element.addEventListener('click', this.onClose)

        if (
          this.els.productsResultsButton?.element &&
          this.els.articlesResultsButton?.element
        ) {
          this.els.productsResultsButton?.element.addEventListener(
            'click',
            this.onProductsClick.bind(this),
          )
          this.els.articlesResultsButton?.element.addEventListener(
            'click',
            this.onArticlesClick.bind(this),
          )
        }

        if (window.yotpoWidgetsContainer) {
          window.yotpoWidgetsContainer.initWidgets()
        }

        if (window.yotpo) {
          window.yotpo.initWidgets()
        }

        this.hideResults(false)
      })
      .catch(error => {
        this.hideResults(true)
        this.hideDefault(false)
        throw error
      })
  }

  getProductSearch (searchTerm) {
    fetch(
      `search/suggest.json?q=${searchTerm}&resources[type]=query,page,product,collection,article&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=body,product_type,tag,title,variants.title,vendor`,
    )
      .then(response => response.json())
      .then(suggestions => {
        const productSuggestions = suggestions.resources.results.products
        const collectionSuggestions = suggestions.resources.results.collections
        const pageSuggestions = suggestions.resources.results.pages
        const articleSuggestions = suggestions.resources.results.articles

        if (
          productSuggestions.length === 0 &&
          collectionSuggestions.length === 0 &&
          pageSuggestions.length === 0 &&
          articleSuggestions.length === 0
        ) {
          this.hideDefault(true)
        }
      })
  }

  open () {
    this.els.search.element.setAttribute('aria-hidden', false)
    this.els.close.element.setAttribute('aria-hidden', false)
    this.externalEls.banner.element.classList.add('hd-Banner-active')
  }

  productsClick () {
    this.els.productsResultsButton?.element.setAttribute('aria-current', true)
    this.els.articlesResultsButton?.element.setAttribute('aria-current', false)
    this.els.productsResults?.element.setAttribute('aria-hidden', false)
    this.els.articlesResults?.element.setAttribute('aria-hidden', true)
  }

  articlesClick () {
    this.els.productsResultsButton?.element.setAttribute('aria-current', false)
    this.els.articlesResultsButton?.element.setAttribute('aria-current', true)
    this.els.productsResults?.element.setAttribute('aria-hidden', true)
    this.els.articlesResults?.element.setAttribute('aria-hidden', false)
  }

  close () {
    this.els.search.element.setAttribute('aria-hidden', true)
    this.els.close.element.setAttribute('aria-hidden', true)
    this.externalEls.banner.element.classList.remove('hd-Banner-active')
    this.els.input.element.value = ''
    this.hideDefault(false)
    this.hideResults(true)
  }

  hideResults (state) {
    this.els.results.element.setAttribute('aria-hidden', state)
  }

  hideDefault (state) {
    this.els.default.element.setAttribute('aria-hidden', state)
  }

  focusAndOpenKeyboard () {
    // Align temp input element approximately where the input element is
    // so the cursor doesn't jump around
    const tempInputEl = document.createElement('input')
    tempInputEl.style.position = 'absolute'
    tempInputEl.style.top = `${this.els.input.element.offsetTop + 7}px`
    tempInputEl.style.left = `${this.els.input.element.offsetLeft}px`
    tempInputEl.style.height = 0
    tempInputEl.style.opacity = 0
    // Put this temp element as a child of the page <body> and focus on it
    document.body.appendChild(tempInputEl)
    tempInputEl.focus()

    // The keyboard is open. Now do a delayed focus on the target element
    window.setTimeout(() => {
      this.els.input.element.focus()
      this.els.input.element.click()
      // Remove the temp element
      document.body.removeChild(tempInputEl)
    }, 500)
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch)
}
